import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { Toaster } from 'sonner';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomeNew from './pages/HomeNew';
import WorkshopsPage from './pages/WorkshopsPage';
import HackathonPage from './pages/HackathonPage';
import IAPLPage from './pages/IAPLPage';
import IAPLDashboardPage from './pages/IAPLDashboardPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import DashboardPage from './pages/DashboardPage';
import AdminPage from './pages/AdminPage';
import VerifiedAdminPage from './pages/VerifiedAdminPage';
import AdminBroadcastEmailPage from './pages/AdminBroadcastEmailPage';
import AdminSetupPage from './pages/AdminSetupPage';
import AdminCompanyLimitsPage from './pages/AdminCompanyLimitsPage';
import ProfileSettings from './pages/ProfileSettings';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import TermsPage from './pages/TermsPage';
import ContactPage from './pages/ContactPage';
import SubmissionPage from './pages/SubmissionPage';
import JuryPanel from './pages/JuryPanel';
import JuryDashboardPage from './pages/JuryDashboardPage';
import ReferralProgramPage from './pages/ReferralProgramPage';
import ReferralAuthPage from './pages/ReferralAuthPage';
import ReferralDashboardPage from './pages/ReferralDashboardPage';
import PaymentCallbackPage from './pages/PaymentCallbackPage';
import WinnersPage from './pages/WinnersPage';
// Coding Platform Pages
import CodingPlatformPage from './pages/CodingPlatformPage';
import ProblemsListPage from './pages/ProblemsListPage';
import ProblemSolvePage from './pages/ProblemSolvePage';
import LeaderboardPage from './pages/LeaderboardPage';
import ContestsPage, { ContestDetailPage } from './pages/ContestsPage';
// Company Assessment Pages
import CompanyAuthPage from './pages/CompanyAuthPage';
import CompanyDashboard from './pages/CompanyDashboard';
import CompanyJobsPage from './pages/CompanyJobsPage';
import CompanyJobDetailPage from './pages/CompanyJobDetailPage';
import AIScoreDashboard from './pages/AIScoreDashboard';
import CreateAssessmentPage from './pages/CreateAssessmentPage';
import AssessmentsListPage from './pages/AssessmentsListPage';
import AssessmentDetailPage from './pages/AssessmentDetailPage';
import AssessmentAnalyticsPage from './pages/AssessmentAnalyticsPage';
import CompanyAnalyticsPage from './pages/CompanyAnalyticsPage';
import CompanySubscriptionPage from './pages/CompanySubscriptionPage';
import CandidatePoolPage from './pages/CandidatePoolPage';
import CandidateTestPage from './pages/CandidateTestPage';
import CodeArenaAuthPage from './pages/CodeArenaAuthPage';
import ArenaActivatePage from './pages/ArenaActivatePage';
// EvalentX Arena National Talent Platform Pages
import CodeArenaPage from './pages/CodeArenaPage';
import CodeArenaProblemsPage from './pages/CodeArenaProblemsPage';
import CodeArenaProblemSolvePage from './pages/CodeArenaProblemSolvePage';
import CodeArenaRankingsPage from './pages/CodeArenaRankingsPage';
import CodeArenaContestsPage, { CodeArenaContestDetailPage } from './pages/CodeArenaContestsPage';
import CodeArenaProfilePage from './pages/CodeArenaProfilePage';
import CodeArenaDashboardPage from './pages/CodeArenaDashboardPage';
import CodeArenaCertificatePage, { CodeArenaMyCertificatesPage } from './pages/CodeArenaCertificatePage';
import CodeArenaJobsPage from './pages/CodeArenaJobsPage';
import CodeArenaJobDetailPage from './pages/CodeArenaJobDetailPage';
import VerifiedTalentLandingPage from './pages/VerifiedTalentLandingPage';
import VerifiedDevelopersPage from './pages/VerifiedDevelopersPage';
import VerifiedTalentVerifyPage from './pages/VerifiedTalentVerifyPage';
import CodeArenaHiringChallengesPage, { CodeArenaHiringChallengeDetailPage } from './pages/CodeArenaHiringChallengesPage';
import HiringChallengeAssessmentPage from './pages/HiringChallengeAssessmentPage';
// Company Dashboard Pages
import CompanyHiringChallengesPage from './pages/CompanyHiringChallengesPage';
import CompanyChallengeDetailPage from './pages/CompanyChallengeDetailPage';
import TalentSearchPage from './pages/TalentSearchPage';
// College Dashboard Pages
import CollegeAuthPage from './pages/CollegeAuthPage';
import CollegeDashboardPage from './pages/CollegeDashboardPage';
import CollegeRankingsPage from './pages/CollegeRankingsPage';
import NationalAnalyticsPage from './pages/NationalAnalyticsPage';
// Stage 10-12 Pages
import PricingPage from './pages/PricingPage';
import CodeArenaReferralPage from './pages/CodeArenaReferralPage';
// Resume & Profile Pages
import ResumeBuilderPage from './pages/ResumeBuilderPage';
import PublicResumePage from './pages/PublicResumePage';
import PublicProfilePage from './pages/PublicProfilePage';
import VerifiedReportPage from './pages/VerifiedReportPage';
import AIRecruiterPage from './pages/AIRecruiterPage';
// Product Upgrades
import CollegesLandingPage from './pages/CollegesLandingPage';
import CompaniesLandingPage from './pages/CompaniesLandingPage';
// School of Future Skills
import FutureSkillsLandingPage from './pages/FutureSkillsLandingPage';
import CourseListingPage from './pages/CourseListingPage';
import CourseDetailsPage from './pages/CourseDetailsPage';
import FutureSkillsPaymentCallback from './pages/FutureSkillsPaymentCallback';
// EvalentX Fellowship (standalone)
import FellowshipLandingPage from './pages/FellowshipLandingPage';
import FellowshipPaymentCallback from './pages/FellowshipPaymentCallback';
// Company Hiring Platform Enhancement
import CompanyProblemsPage from './pages/CompanyProblemsPage';
import CompanyLandingPage from './pages/CompanyLandingPage';
import JobBoardPage from './pages/JobBoardPage';
import MyApplicationsPage from './pages/MyApplicationsPage';
import ShortlistedCandidatesPage from './pages/ShortlistedCandidatesPage';
import CompanyVerifiedShortlistPage from './pages/CompanyVerifiedShortlistPage';
import InterviewInsightsPage from './pages/InterviewInsightsPage';
// Company Email Center
import CompanyEmailCenterPage from './pages/CompanyEmailCenterPage';
// Admin Pages
import AdminEmailApprovalPage from './pages/AdminEmailApprovalPage';
// Resume Upgrade
import ResumeUpgradePage from './pages/ResumeUpgradePage';
// Enterprise Challenge Hosting
import EnterpriseChallengePage from './pages/EnterpriseChallengePage';
import CompanyEnterpriseHostingPage from './pages/CompanyEnterpriseHostingPage';
import CompanyEnterpriseDetailPage from './pages/CompanyEnterpriseDetailPage';
import EnterpriseAnalyticsPage from './pages/EnterpriseAnalyticsPage';
import EnterpriseAssessmentPage from './pages/EnterpriseAssessmentPage';
import ProctorDashboard from './pages/ProctorDashboard';
import EnterpriseLandingPageBuilder from './pages/EnterpriseLandingPageBuilder';
// Event Hosting
import CompanyEventsPage from './pages/CompanyEventsPage';
import CompanyProfilePage from './pages/CompanyProfilePage';
import EventParticipantsPage from './pages/EventParticipantsPage';
import EventPage from './pages/EventPage';
import EventTicketPage from './pages/EventTicketPage';
import CodeArenaEventsPage from './pages/CodeArenaEventsPage';
import EventInvitePage from './pages/EventInvitePage';
// Mock Interview
import MockInterviewPage from './pages/MockInterviewPage';
import MockInterviewSessionPage from './pages/MockInterviewSessionPage';
import MockInterviewPaymentCallback from './pages/MockInterviewPaymentCallback';
import './App.css';

// Scroll to top on route changes
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

// Layout wrapper to conditionally show Navbar/Footer
const AppLayout = ({ children }) => {
  const location = useLocation();
  // Hide Navbar/Footer for admin, referral, jury-dashboard, iapl-dashboard, company, assessment, codearena/auth, problem solving pages, and the new redesigned home page (which has its own nav/footer)
  const hideNavFooter = 
    location.pathname === '/' ||
    location.pathname === '/codearena' ||
    location.pathname === '/colleges' ||
    location.pathname === '/hackathon' ||
    location.pathname === '/verified-developers' ||
    location.pathname.startsWith('/admin') || 
    location.pathname.startsWith('/referral') || 
    location.pathname.startsWith('/jury-dashboard') ||
    location.pathname.startsWith('/iapl-dashboard') ||
    location.pathname.startsWith('/coding/problem/') ||
    location.pathname.startsWith('/company') ||
    location.pathname.startsWith('/assessment') ||
    location.pathname.startsWith('/codearena/auth') ||
    location.pathname.startsWith('/codearena/activate') ||
    location.pathname.startsWith('/codearena/problem/') ||
    location.pathname.startsWith('/codearena/dashboard') ||
    location.pathname.startsWith('/codearena/mock-interview') ||
    location.pathname.includes('/assessment/') ||
    location.pathname.match(/^\/enterprise\/[^/]+\/assessment/);
  
  // Only lock scroll for actual assessment-taking pages (not admin/company pages)
  const lockScroll = 
    location.pathname.startsWith('/assessment') ||
    location.pathname.includes('/assessment/') ||
    location.pathname.match(/^\/enterprise\/[^/]+\/assessment/);
  
  return (
    <div className={`flex flex-col min-h-screen ${hideNavFooter ? 'assessment-fullscreen' : ''}`}>
      {!hideNavFooter && <Navbar />}
      <main className={`flex-grow ${lockScroll ? 'h-screen overflow-hidden' : ''}`}>
        {children}
      </main>
      {!hideNavFooter && <Footer />}
    </div>
  );
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
        <ScrollToTop />
        <AppLayout>
          <Routes>
            <Route path="/" element={<HomeNew />} />
            <Route path="/workshops" element={<WorkshopsPage />} />
            <Route path="/hackathon" element={<HackathonPage />} />
            <Route path="/ai-league" element={<IAPLPage />} />
            <Route path="/iapl-dashboard" element={<IAPLDashboardPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/forgot-password/:accountType" element={<ForgotPasswordPage />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/profile" element={<ProfileSettings />} />
            <Route path="/submission" element={<SubmissionPage />} />
            <Route path="/jury-panel" element={<JuryPanel />} />
            <Route path="/jury-dashboard" element={<JuryDashboardPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/admin/verified-talent" element={<VerifiedAdminPage />} />
            <Route path="/admin/broadcast" element={<AdminBroadcastEmailPage />} />
            <Route path="/admin/setup" element={<AdminSetupPage />} />
            <Route path="/admin/company-limits" element={<AdminCompanyLimitsPage />} />
            <Route path="/admin/email-approval" element={<AdminEmailApprovalPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/winners" element={<WinnersPage />} />
            {/* Payment Callback Route */}
            <Route path="/payment-callback" element={<PaymentCallbackPage />} />
            {/* Referral Partner Routes */}
            <Route path="/referral" element={<ReferralProgramPage />} />
            <Route path="/referral/login" element={<ReferralAuthPage mode="login" />} />
            <Route path="/referral/register" element={<ReferralAuthPage mode="register" />} />
            <Route path="/referral/dashboard" element={<ReferralDashboardPage />} />
            {/* Coding Platform Routes */}
            <Route path="/coding" element={<CodingPlatformPage />} />
            <Route path="/coding/problems" element={<ProblemsListPage />} />
            <Route path="/coding/problem/:problemId" element={<ProblemSolvePage />} />
            <Route path="/coding/leaderboard" element={<LeaderboardPage />} />
            <Route path="/codearena/leaderboard" element={<LeaderboardPage />} />
            <Route path="/coding/contests" element={<ContestsPage />} />
            <Route path="/coding/contest/:contestId" element={<ContestDetailPage />} />
            {/* EvalentX Arena Individual Student Routes */}
            <Route path="/codearena/auth" element={<CodeArenaAuthPage />} />
            <Route path="/codearena/activate" element={<ArenaActivatePage />} />
            {/* EvalentX Arena National Talent Platform Routes */}
            <Route path="/codearena" element={<CodeArenaPage />} />
            <Route path="/codearena/problems" element={<CodeArenaProblemsPage />} />
            <Route path="/codearena/problem/:problemId" element={<CodeArenaProblemSolvePage />} />
            <Route path="/codearena/rankings" element={<CodeArenaRankingsPage />} />
            <Route path="/codearena/contests" element={<CodeArenaContestsPage />} />
            <Route path="/codearena/contest/:contestId" element={<CodeArenaContestDetailPage />} />
            <Route path="/codearena/profile/:username" element={<CodeArenaProfilePage />} />
            <Route path="/codearena/dashboard" element={<CodeArenaDashboardPage />} />
            <Route path="/codearena/certificate/:certId" element={<CodeArenaCertificatePage />} />
            <Route path="/codearena/verify" element={<CodeArenaCertificatePage />} />
            <Route path="/codearena/certificates" element={<CodeArenaMyCertificatesPage />} />
            <Route path="/codearena/jobs" element={<CodeArenaJobsPage />} />
            <Route path="/codearena/jobs/:jobId" element={<CodeArenaJobDetailPage />} />
            {/* Public shareable short URL - /jobs/:jobId */}
            <Route path="/jobs/:jobId" element={<CodeArenaJobDetailPage />} />
            {/* EvalentX Verified Talent Profile */}
            <Route path="/verified-talent" element={<VerifiedTalentLandingPage />} />
            <Route path="/verified-developers" element={<VerifiedDevelopersPage />} />
            <Route path="/verified-talent/verify" element={<VerifiedTalentVerifyPage />} />
            <Route path="/codearena/job-board" element={<JobBoardPage />} />
            <Route path="/codearena/my-applications" element={<MyApplicationsPage />} />
            <Route path="/codearena/hiring-challenges" element={<CodeArenaHiringChallengesPage />} />
            <Route path="/codearena/hiring-challenges/:challengeId" element={<CodeArenaHiringChallengeDetailPage />} />
            <Route path="/codearena/assessment/:challengeId/start" element={<HiringChallengeAssessmentPage />} />
            <Route path="/codearena/college-rankings" element={<CollegeRankingsPage />} />
            <Route path="/codearena/analytics" element={<NationalAnalyticsPage />} />
            <Route path="/codearena/referrals" element={<CodeArenaReferralPage />} />
            <Route path="/codearena/resume" element={<ResumeBuilderPage />} />
            <Route path="/codearena/resume-upgrade" element={<ResumeUpgradePage />} />
            {/* Public Resume & Profile Pages */}
            <Route path="/resume/:username" element={<PublicResumePage />} />
            <Route path="/profile/:username" element={<PublicProfilePage />} />
            <Route path="/verify/:vid" element={<VerifiedReportPage />} />
            {/* Landing Pages */}
            <Route path="/colleges" element={<CollegesLandingPage />} />
            <Route path="/companies" element={<CompaniesLandingPage />} />
            {/* School of Future Skills Routes */}
            <Route path="/future-skills" element={<FutureSkillsLandingPage />} />
            <Route path="/future-skills/courses" element={<CourseListingPage />} />
            <Route path="/future-skills/course/:courseSlug" element={<CourseDetailsPage />} />
            <Route path="/future-skills/enrollment/callback" element={<FutureSkillsPaymentCallback />} />
            {/* EvalentX Academy — same components, friendlier URL (legacy /future-skills paths preserved) */}
            <Route path="/academy" element={<FutureSkillsLandingPage />} />
            <Route path="/academy/courses" element={<CourseListingPage />} />
            <Route path="/academy/course/:courseSlug" element={<CourseDetailsPage />} />
            <Route path="/academy/enrollment/callback" element={<FutureSkillsPaymentCallback />} />
            {/* EvalentX Fellowship Routes (standalone) */}
            <Route path="/fellowship" element={<FellowshipLandingPage />} />
            <Route path="/fellowship/payment-callback" element={<FellowshipPaymentCallback />} />
            {/* Pricing Page */}
            <Route path="/pricing" element={<PricingPage />} />
            {/* College Dashboard Routes */}
            <Route path="/college/auth" element={<CollegeAuthPage />} />
            <Route path="/college/dashboard" element={<CollegeDashboardPage />} />
            {/* Company Assessment Routes */}
            <Route path="/company" element={<CompanyLandingPage />} />
            <Route path="/company/auth" element={<CompanyAuthPage />} />
            <Route path="/company/login" element={<CompanyAuthPage />} />
            <Route path="/company/dashboard" element={<CompanyDashboard />} />
            <Route path="/company/jobs" element={<CompanyJobsPage />} />
            <Route path="/company/jobs/:jobId" element={<CompanyJobDetailPage />} />
            <Route path="/company/jobs/:jobId/ai-dashboard" element={<AIScoreDashboard />} />
            <Route path="/company/problems" element={<CompanyProblemsPage />} />
            <Route path="/company/hiring-challenges" element={<CompanyHiringChallengesPage />} />
            <Route path="/company/hiring-challenges/:challengeId" element={<CompanyChallengeDetailPage />} />
            <Route path="/company/talent-search" element={<TalentSearchPage />} />
            <Route path="/company/ai-recruiter" element={<AIRecruiterPage />} />
            <Route path="/company/assessments" element={<AssessmentsListPage />} />
            <Route path="/company/assessments/create" element={<CreateAssessmentPage />} />
            <Route path="/company/assessments/:id" element={<AssessmentDetailPage />} />
            <Route path="/company/assessments/:id/analytics" element={<AssessmentAnalyticsPage />} />
            <Route path="/company/shortlisted" element={<ShortlistedCandidatesPage />} />
            <Route path="/company/verified-shortlist" element={<CompanyVerifiedShortlistPage />} />
            <Route path="/company/analytics" element={<CompanyAnalyticsPage />} />
            <Route path="/company/subscription" element={<CompanySubscriptionPage />} />
            <Route path="/company/candidates" element={<CandidatePoolPage />} />
            <Route path="/company/interview-insights" element={<InterviewInsightsPage />} />
            <Route path="/company/email-center" element={<CompanyEmailCenterPage />} />
            <Route path="/company/enterprise" element={<CompanyEnterpriseHostingPage />} />
            <Route path="/company/profile" element={<CompanyProfilePage />} />
            <Route path="/company/enterprise/payment-callback" element={<CompanyEnterpriseHostingPage />} />
            <Route path="/company/enterprise/challenges/:challengeId" element={<CompanyEnterpriseDetailPage />} />
            <Route path="/company/enterprise/challenges/:challengeId/analytics" element={<EnterpriseAnalyticsPage />} />
            <Route path="/company/enterprise/challenges/:challengeId/proctor" element={<ProctorDashboard />} />
            <Route path="/company/enterprise/challenges/:challengeId/landing-builder" element={<EnterpriseLandingPageBuilder />} />
            {/* Event Hosting Routes */}
            <Route path="/company/events" element={<CompanyEventsPage />} />
            <Route path="/company/events/:eventId/participants" element={<EventParticipantsPage />} />
            <Route path="/events/invite/:token" element={<EventInvitePage />} />
            <Route path="/events/:eventId" element={<EventPage />} />
            <Route path="/events/:eventId/ticket/:registrationId" element={<EventTicketPage />} />
            <Route path="/codearena/events" element={<CodeArenaEventsPage />} />
            {/* Mock Interview Routes */}
            <Route path="/codearena/mock-interview" element={<MockInterviewPage />} />
            <Route path="/codearena/mock-interview/payment-callback" element={<MockInterviewPaymentCallback />} />
            <Route path="/codearena/mock-interview/:sessionId" element={<MockInterviewSessionPage />} />
            {/* Candidate Assessment Routes */}
            <Route path="/assessment/:id" element={<CandidateTestPage />} />
            <Route path="/assessment/:id/register" element={<CandidateTestPage />} />
            {/* Enterprise Challenge Public Landing Pages */}
            <Route path="/enterprise/:orgSlug/:challengeSlug" element={<EnterpriseChallengePage />} />
            <Route path="/enterprise/preview/:challengeId" element={<EnterpriseChallengePage />} />
            <Route path="/enterprise/:challengeId/assessment/:roundId" element={<EnterpriseAssessmentPage />} />
          </Routes>
        </AppLayout>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;